export const frontend = 'https://annotator.zehua.li/';
export const backend = 'https://backend.annotator.zehua.li/';
